// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__9N65A","rightAdornment":"Header_rightAdornment__oGkiK"};